import { hasValidEndDate } from './hasValidEndDate';

/**
 * Checks if a given end date has expired.
 *
 * The date is considered expired if the current date and time is after
 * 23:59:59 of the provided end date. Missing (nullish) or unparseable dates are
 * treated as "not expired".
 *
 * @param endDate The end date of the license (ISO or date string), or a
 *   nullish/invalid value.
 * @returns A boolean value.
 */
export function isExpired(endDate?: string | null): boolean {
  if (!hasValidEndDate(endDate)) {
    return false;
  }

  const expiry = new Date(endDate).setHours(23, 59, 59);

  return expiry < Date.now();
}
